import { render, staticRenderFns } from "./EditAccountModal.vue?vue&type=template&id=2fe6bba9&scoped=true"
import script from "./EditAccountModal.vue?vue&type=script&lang=ts"
export * from "./EditAccountModal.vue?vue&type=script&lang=ts"
import style0 from "./EditAccountModal.vue?vue&type=style&index=0&id=2fe6bba9&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6bba9",
  null
  
)

export default component.exports